import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
import ClientConfigEdit from './clientconfig-edit'
import ClientConfigList from './clientconfig-list'
import ClientConfigAdd from './clientconfig-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const ClientConfig = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.CLIENT_CONFIG}
                        component={ClientConfigList}
                    />
                    <Route
                        exact
                        path={ROUTES.CLIENT_CONFIG_EDIT}
                        component={ClientConfigEdit}
                    />
                    <Route
                        exact
                        path={ROUTES.CLIENT_CONFIG_ADD}
                        component={ClientConfigAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(ClientConfig)



// WEBPACK FOOTER //
// ./src/pages/client-config/index.js